<p class="text-black text-center">Solicitud de cambio de contraseña</p>
<form class="space-y-4 md:space-y-6">
  <div>
    <label for="email" appFormLabel>Email</label>
    <input [(ngModel)]="email" type="email" name="email" id="email" appFormInputText placeholder="example@alonso.com" required="">
  </div>
  <div *ngIf="successMessage" class="p-4 mb-4 text-sm text-white rounded-lg bg-green" role="alert">
    {{ successMessage }}
  </div>
  <div class="flex items-center justify-start gap-2">
    <span class="text-xs text-black">O</span>
    <a routerLink="/login" class="text-sm font-medium text-primary hover:underline ">Iniciar sesión</a>
  </div>

  <button [disabled]="loading" (click)="restore()" type="submit" class="w-full disabled:bg-darkGray text-white bg-primary hover:opacity-85 focus:ring-4 focus:outline-none focus:ring-primary font-medium rounded-lg text-sm px-5 py-2.5 text-center ">
    Recuperar
  </button>
</form>
